import { CheckIcon } from '@heroicons/react/24/solid';

import useAccountQuery from 'api/queries/useAccountQuery';
import { Alert } from 'honeydew/Alert';
import Button from 'honeydew/Button';
import { PlusBenefitsWeeklyDealsIcon } from 'honeydew/icons/PlusMembership';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';
import { formatDateString } from 'utils/dateUtils';
import { getOrderMin } from 'utils/orderUtils';

export function CancelPlanPlusMembershipInfoModule() {
    const {
        membership,
        plusMembershipBranding,
        price: { annual: annualPrice },
        shippingFees,
        trial,
    } = useAccountPlusMembershipHook();
    const membershipExpirationString = formatDateString(membership?.endDate, false, true);
    const trialExpirationString = formatDateString(trial?.endDate);
    const { data: account } = useAccountQuery();
    const orderMin = getOrderMin(account);

    const descriptionCopy = membership
        ? `You didn’t think we’d forget about your benefits, did you? Your ${plusMembershipBranding} membership is still active with your new Flex Plan, and it will ${
              membership.isAutoRenew ? 'renew' : 'expire'
          } on ${membershipExpirationString}.`
        : `Don’t forget, your ${plusMembershipBranding} free trial is still active! When your trial ends on ${trialExpirationString}, you’ll automatically be charged the $${annualPrice} annual fee.`;
    const shippingCopy = shippingFees?.plusMembershipShippingFee
        ? `$${shippingFees?.plusMembershipShippingFee} shipping on orders $${orderMin}+`
        : `Free shipping on orders $${orderMin}+`;

    const listItem = (title) => (
        <li className="flex">
            <CheckIcon className="w-20 self-center justify-self-center pr-5 text-blueberry" />
            <p>{title}</p>
        </li>
    );

    return (
        <div className="px-20 py-10">
            <div className="mb-20">
                <Alert variant="success">
                    <p>
                        <span className="font-grotesk-bold">Your Grocery Subscription has been canceled.</span>
                        &nbsp;You’ll no longer get automatic orders, but you can still shop with your Flex Plan.
                    </p>
                </Alert>
            </div>
            <div className="flex flex-col items-center gap-10 text-center">
                <PlusBenefitsWeeklyDealsIcon width={50} />
                <h1 className="text-heading-sm">Your Flex Plan is even better with {plusMembershipBranding}</h1>
                <div className="flex flex-col items-center gap-15">
                    <p>{descriptionCopy}</p>
                    <ul className="text-body-md pl-20">
                        {listItem('Exclusive weekly deals')}
                        {listItem(shippingCopy)}
                        {listItem('Fight hunger with every order')}
                    </ul>
                    <Button as="link" to="/account/membership" size="md" variant="plusMembership">
                        {membership ? `Manage ${plusMembershipBranding} Membership` : `Go to ${plusMembershipBranding}`}
                    </Button>
                </div>
            </div>
        </div>
    );
}
